module.exports = {"id":"120312","name":"Michael Dawson","rating":"72","photo":"./data/images/photos/3/120312.png","club":{"name":"Hull City","logo":"./data/images/clubs/HullCity.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelDawson0.json
// module id = 2982
// module chunks = 0